import Common from '../../wp-controlers/common-panel/geralAttributes';

export default {
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  imagePosition: {
    type: 'string',
    default: 'image-left',
  },
  hideDesktop: {
    type: 'boolean',
    default: false,
  },
  hideMobile: {
    type: 'boolean',
    default: false,
  },
  absolute: {
    type: 'boolean',
    default: false,
  },
  positionAbsolute: {
    type: 'string',
    default: 'absolute-left',
  },
  positionAbsoluteVertical: {
    type: 'string',
    default: 'absolute-top',
  },
  borderRadius: {
    type: 'int',
    default: 0,
  },
  ...Common,
};
